<template>
    <CompassModal
        ref="RevokeDialog"
        v-model:visible="showModal"
        size="small"
        :title="$t.__('common.actions.revoke_access')"
        class="revoke-confirmation"
        @closed="closeModal"
    >
        <template #default>
            <p class="typographies-paragraph-medium-regular">
                {{
                    $l10n.__(
                        'Vous êtes sur le point d’annuler l’accès à votre compte aux collaborateurs Sellsy. Cette action est définitive, êtes-vous certain de vouloir annuler cet accès ?',
                    )
                }}
            </p>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="closeModal"
                />
                <CompassButton
                    ref="revokeButton"
                    :label="$t.__('common.actions.revoke_access')"
                    type="primary-destructive"
                    @click="handleRevoke"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
import { revokeAuthorization } from 'api/impersonate/impersonateService';

export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        uuid: {
            type: String,
        },
    },
    data() {
        return {
            showModal: this.visible,
        };
    },
    watch: {
        visible(newValue) {
            this.showModal = newValue;
        },
    },
    methods: {
        handleRevoke() {
            revokeAuthorization(this.uuid)
                .then(() => {
                    this.$emit('revoke-success');
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$l10n.__("L'accès a bien été révoqué"),
                        close: true,
                    });
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: this.$l10n.__('Une erreur est survenue, merci de réessayer'),
                        close: true,
                    });
                })
                .finally(() => (this.showModal = false));
        },
        closeModal() {
            this.showModal = false;
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.revoke-confirmation {
    .compass-modal__modal__content {
        p {
            margin: 0;
        }
    }
    .compass-modal__modal__footer {
        .dialog__footer {
            display: flex;
            flex-direction: row;
            gap: var(--spacing-3);
            justify-content: flex-end;
            padding: var(--spacing-4) var(--spacing-5) var(--spacing-5);
        }
    }
}
</style>
